<div class="container" (click)="onClicked()">
  <div class="selected">
    <!-- Static label mode: show ONLY static label -->
    <ng-container *ngIf="staticLabel; else valueBlock">
      <ng-container *ngTemplateOutlet="staticLabelTemplate"></ng-container>
    </ng-container>

    <!-- Normal mode: show current selected value -->
    <ng-template #valueBlock>
      <ng-container
        *ngTemplateOutlet="valueTemplate || defaultValueTemplate; context: { $implicit: value }"
      ></ng-container>
    </ng-template>
  </div>

  <i class="material-icons">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
</div>

<ng-template #drawer>
  <div class="drawer">
    <div class="list">
      <div class="padding-container">
        <div *ngFor="let item of items" class="item" (click)="onItemClicked(item, $event)" (mousedown)="onItemClicked(item, $event)">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate || defaultItemTemplate;
              context: { $implicit: item, isSelected: item === value }
            "
          ></ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="drawerBottomTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #defaultItemTemplate let-item>{{ item }}</ng-template>
<ng-template #defaultValueTemplate let-item>{{ item }}</ng-template>
<ng-template #staticLabelTemplate>
  {{ staticLabel }}
  <div class="separator"></div>
</ng-template>
